'use strict';

var tuneInRequest = require('../tuneInRequest');

/**
 * The main service for CRUD operations on favorites
 * @param {object} config - The configuration object
 * @param {object} apiContext - The API context that contains, tokens, cookies, headers, etc
 * @param {function} applyReauth - Reauthorize the user when adjusting favorites
 */
module.exports = function browseService(config, apiContext, applyReauth) {
  var url = config.domains.opml + '/favorites.ashx';

  /**
   * Add a folder to favorites
   * @param {string} name - Name of folder to be added
   */
  function addFolder(_ref) {
    var name = _ref.name;

    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'addFolder',
        name: name
      }
    }, apiContext);
  }

  /**
   * Remove a folder from favorites
   * @param {string} folderId - The folder ID to be removed
   */
  function removeFolder(_ref2) {
    var folderId = _ref2.folderId;

    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'removeFolder',
        folderId: folderId
      }
    }, apiContext);
  }

  /**
   * Add an item to favorites
   * @param {string} guideId - id of item to add to favorites
   */
  function add(guideId) {
    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'add',
        id: guideId
      }
    }, apiContext);
  }

  /**
   * Add multiple items to favorites
   * @param {array} guideIds - The ids of items to be added
   */
  function bulkAddInterests(guideIds) {
    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'addInterests',
        id: guideIds
      }
    }, apiContext);
  }

  /**
   * Remove a favorited item
   *
   * @param {string} favoriteIdOrGuideId -
   * All favorited items, except Categories, use the favoriteid
   * when a Category is chosen to be removed we have to pass the guideId to the id param.
   */
  function remove(favoriteIdOrGuideId) {
    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'remove',
        id: favoriteIdOrGuideId,
        favoriteId: favoriteIdOrGuideId
      }
    }, apiContext);
  }

  /**
   * Reorder favorites
   * @param {string} favoriteId - The ID of the favorited item
   * @param {string} index - The index of the sort order to be set
   */
  function order(_ref3) {
    var favoriteId = _ref3.favoriteId,
        index = _ref3.index;

    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'setSort',
        favoriteId: favoriteId,
        sortOrder: index
      }
    }, apiContext);
  }

  /**
   * Move an item to a folder
   * @param {string} favoriteId - The ID of the favorite item
   * @param {string} folderId - The ID of the folder to move the item to
   */
  function move(_ref4) {
    var favoriteId = _ref4.favoriteId,
        folderId = _ref4.folderId;

    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'move',
        favoriteId: favoriteId,
        folderId: folderId
      }
    }, apiContext);
  }

  /**
   * Set a particular folder to be the default
   * @param {string} folderId - The ID of the folder to set the default to
   */
  function setDefaultFolder(_ref5) {
    var folderId = _ref5.folderId;

    return tuneInRequest({
      url: url,
      params: {
        render: 'json',
        c: 'setDefaultFolder',
        folderId: folderId
      }
    }, apiContext);
  }

  return {
    addFolder: applyReauth(addFolder),
    removeFolder: applyReauth(removeFolder),
    add: applyReauth(add),
    remove: applyReauth(remove),
    order: applyReauth(order),
    move: applyReauth(move),
    setDefaultFolder: applyReauth(setDefaultFolder),
    bulkAddInterests: bulkAddInterests
  };
};
//# sourceMappingURL=favorites.js.map